import React from 'react';
import _RegisterForm from './_RegisterForm.scss';
import Recaptcha from 'react-recaptcha';
import {Link, withRouter} from 'react-router-dom';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import {Input} from 'components/vitrade-forms/common';
import {User} from 'api';
import {login} from 'base/actions';
import {TermsOfUse} from 'components/partials/terms-of-use';
import CONFIG from 'base/constants/config';
import FacebookLogin from 'base/lib/social-login/Facebook';
import {loginWithFacebook} from 'base/actions/social-login/facebook';


class RegisterForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formRegistration'] = [];

    this.state = {
      fullname: '',
      email: '',
      address: '',
      phone: '',
      gender: '',
      agreeTOS: false,
      gender: 0,
      status: 1
    };

    this.facebookLoginCheck = this.facebookLoginCheck.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isAuthenticated) {
      this.props.history.push('/dashboard');
    }
  }

  facebookLoginCheck() {
    FB.login((fbLoginResponse) => {
      if (fbLoginResponse.status === 'connected') {
        this.props.dispatch(loginWithFacebook(fbLoginResponse.authResponse)).then(response => {
          this.setState({loading: false});

          if (response.isAuthenticated === true) {
            toastr.success('Thành công!', 'Bạn đã đăng nhập thành công.');

            // window.location = this.props.defaultPage;
            this.props.history.push(this.props.defaultPage);
          } else {
            toastr.error('Đăng nhập thất bại!', 'Có lỗi xảy ra. Bạn vui lòng thử lại');
          }
        });
      } else if (response.status === 'not_authorized') {
        // The person is logged into Facebook, but not your app.
        // document.getElementById('status').innerHTML = 'Please log into this app.';
      } else {

      }
    }, {scope: 'email'});
  }

  submitForm(e) {
    e.preventDefault();

    if (this.validateSubmitForm()) {
      let {
        agreeTOS,
        ...data
      } = this.state;
      data.password = this.refs.password.validator.input.value;

      User.actions.register.request({}, {data: data}).then(response => {
        toastr.success('Thành công!', 'Bạn đã đăng ký thành công. Bạn vui lòng đợi trong giây lát.');

        this.props.dispatch(login(this.state.email, this.refs.password.validator.input.value, false)).then(response => {
          // this.setState({loading: false});

          if (response.isAuthenticated === true) {
            // toastr.success('Thành công!', 'Bạn đã đăng nhập thành công.');
            this.props.history.push('/dashboard');
          } else {
            this.props.history.push('/signin');
          }
        }).catch(err => {
          console.log(err)
        });

      }).catch(err => {
        console.log(err);
      });
    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
    }
  }

  onChange(name, e) {
    this.setState({[name]: e.target.value})
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formRegistration'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
      }
    );

    if (!pass) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }

    // checkpassword
    let password = this.refs.password.validator.input.value;
    let repassword = this.refs.repassword.validator.input.value;

    if (!password) {
      toastr.error('Lỗi!', 'Bạn vui lòng điền vào mật khẩu');
      return false;
    } else if (password.length < 6) {
      toastr.error('Lỗi!', 'Mật khẩu phải có ít nhất 6 ký tự');
      return false;
    } else if (password != repassword) {
      toastr.error('Lỗi!', 'Hai mật khẩu bạn nhập vào không trùng khớp');
      return false;
    }

    return pass;
  }

  toggleAgreeTOS() {
    this.setState({
      agreeTOS: !this.state.agreeTOS
    });
  }

  render() {
    return (
      <div className="register-box">
        <div className="register-logo">
          <b>Đăng ký</b>
        </div>
        <form onSubmit={this.submitForm.bind(this)}>
          <div className="register-box-body">
            <Input type="text" placeholder="Tên..." className='has-feedback fg-custom' iconClassName='fa-user-o' value={this.state.fullname} required={true} onChange={this.onChange.bind(this, 'fullname')} bindValidator={this} channel="formRegistration" errorMessage="Tên không được để trống"/>
            <Input type="email" placeholder="Email..." className='has-feedback fg-custom' iconClassName='fa-at' value={this.state.email} onChange={this.onChange.bind(this, 'email')} required={true} bindValidator={this} channel="formRegistration" errorMessage="Bạn vui lòng cung cấp email"/>
            <Input type="text" placeholder="Địa chỉ..." className='has-feedback fg-custom' value={this.state.address} onChange={this.onChange.bind(this, 'address')} iconClassName='fa-map-marker'/>
            <Input type="text" placeholder="Số điện thoại..." className='has-feedback fg-custom' iconClassName="fa-mobile" value={this.state.phone} onChange={this.onChange.bind(this, 'phone')} required={true} bindValidator={this} channel="formRegistration" errorMessage="Bạn vui lòng cung cấp số điện thoại"/>
            <Input type="password" placeholder="Mật khẩu..." className='has-feedback fg-custom' iconClassName='fa-unlock-alt' ref='password'/>
            <Input type="password" placeholder="Nhập lại mật khẩu..." className='has-feedback fg-custom' iconClassName='fa-unlock-alt' ref='repassword'/>

            <div>
              <div className="checkbox term">
                <label>
                  <input type="checkbox" onChange={this.toggleAgreeTOS.bind(this)}/>
                  Tôi đồng ý với
                  <Link to="/cms/dieu-khoan-and-dieu-kien-giao-dich" className="terms-of-use">&nbsp;điều kiện sử dụng và chính sách của DaklakTrade</Link>
                </label>
              </div>
            </div>
            <div className="google-captcha">
              <Recaptcha sitekey={CONFIG.CAPTCHA_KEY}/>
            </div>
            <div>
              <button type="submit" disabled={!this.state.agreeTOS} className="btn btn-primary btn-block btn-flat btn-submit text-btn">ĐĂNG KÝ</button>
            </div>

            <div className="social-auth-links text-center">
              <hr className="hr-text" data-content="hoặc"/>
              <button type="button" className="btn btn-block btn-fb btn-flat text-btn"
                onClick={this.facebookLoginCheck}
              >
                <i className="fa fa-facebook"></i>
                ĐĂNG NHẬP VỚI FACEBOOK
              </button>
            </div>
          </div>
        </form>
        <div className="register-now">
          <p>Bạn đã có tài khoản?
            <Link to="/signin">
              <b>Đăng nhập ngay</b>
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

RegisterForm.defaultProps = {
  validators: {}
}

const bindStateToProps = state => {
  return {auth: state.auth}
}

export default withRouter(connect(bindStateToProps)(RegisterForm));



// WEBPACK FOOTER //
// ./components/register/RegisterForm.jsx